import { useTheme } from '../context/ThemeProvider';
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import useAxiosPrivate from "../hooks/useAxiosPrivate";
import MainLoader from "../components/MainLoader";
import useAuth from '../hooks/useAuth';
import { prepareSchoolLanding } from '../config/schoolLanding';

export default function ImpersonateRedirect() {
  const { auth, setAuth, setShowLoader } = useAuth();

  const theme = useTheme();
  const axios = useAxiosPrivate();
  const location = useLocation();
  const navigate = useNavigate()

  useEffect(() => {
    verifyAndRedirect()
  }, []);

  const verifyAndRedirect = async () => {
    
    setShowLoader(true);
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const expires_at = params.get("expires_at");

    if (auth.user) {
      window.location.href = "/"
      return
    }

    if (!token) {
      console.error("No Token")
      window.location.href = "/"
      return
    }

    localStorage.setItem("token", token);
    localStorage.setItem("impersonating", "true");
    if (expires_at) {
      localStorage.setItem("impersonation_expire", expires_at);
    }

    try {
      const response = await axios.get('/impersonate-login', {
        params: { token, expires_at },
      })
      const { user, schools } = response.data
      const selectedSchoolId = schools?.length === 1 ? String(schools[0].id) : null

      localStorage.removeItem('currentPolicy')
      localStorage.removeItem('orgType')
      setAuth({ user, token, schools, selectedSchoolId })

      if (!schools?.length) {
        console.error("No Schools for this contact found")
        window.location.href = "/"
        return
      }

      if (schools.length > 1) {
        navigate('/account-select', { replace: true })
      } else {
        const destination = await prepareSchoolLanding(axios, {
          user: response.data.user,
          schools: response.data.schools,
          selectedSchoolId,
          token,
          theme,
        })
        navigate(destination, { replace: true })
      }
    } catch (err) {
      console.error("Failed to login impersonated user", err)
      localStorage.removeItem('token')
      localStorage.removeItem('impersonating')
      localStorage.removeItem('impersonation_expire')
      window.location.href = "/"
    } finally {
      setShowLoader(false);
    }
  }

  return <MainLoader />
}


